import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepInformationFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepInformationFormContainer.jsx';

const NewProfileStepInformation = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Stakeholder | ChangeSync</title>
    </Helmet>
    <StepInformationFormContainer projectId={projectId} slug={slug} />
  </>
);

NewProfileStepInformation.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewProfileStepInformation));
